import { UIState } from './types';
import { Module } from '../../../node_modules/vuex';
import { RootState } from '../types';
import { mutations } from './mutations';

export const state: UIState = {
    appVisible: true,
    taskbarVisible: true,
    sidebarVisible: false,
    sidebarExpanded: true
};

const namespaced = true;

export const ui: Module<UIState, RootState> = {
    namespaced,
    state,
    mutations
};
